module.exports = "<div id=\"path-not-found\">\n\t<h2>Stran ne obstaja</h2>\n</div>"